import { Button } from "@ui/Button";
import { Card } from "@ui/Card";
import { MaterialSymbol } from "@ui/MaterialSymbol";
import { HStack, VStack } from "@ui/Stack";
import { Text } from "@ui/typography/Text";
import { Show } from "solid-js";
import { askPageVars } from "./pageVars";

type Props = {
	question: string;
	status: "thinking" | "error";
	error?: string | null;
	threadPath?: string;
};

export const AnswerCard = (props: Props) => {
	const vars = askPageVars();

	return (
		<Card noPadding>
			<HStack
				align="center"
				spacing="intermediate"
				style={{ padding: "1rem", "border-bottom": "1px solid var(--line)" }}
			>
				<MaterialSymbol symbol="auto_awesome" color="primary" />
				<Text
					as="span"
					size="intermediate"
					weight="semi-bold"
					color="ink"
					style={{ flex: 1 }}
				>
					{props.question}
				</Text>
			</HStack>
			<Show when={props.status === "thinking"}>
				<VStack spacing="intermediate" style={{ padding: "1rem" }}>
					<HStack align="center" spacing="small">
						<MaterialSymbol symbol="graphic_eq" color="primary" />
						<Text family="mono" size="xsmall" color="fg3">
							Watching {vars.influencer_display_name}'s clips, frame by frame…
						</Text>
					</HStack>
					<span class="askgvt1-shimmer" />
					<span class="askgvt1-shimmer" style={{ width: "82%" }} />
					<span class="askgvt1-shimmer" style={{ width: "54%" }} />
				</VStack>
			</Show>
			<Show when={props.status === "error"}>
				<VStack spacing="large" style={{ padding: "1rem" }}>
					<Text size="small" color="error">
						{props.error}
					</Text>
					<Show when={props.threadPath}>
						<Button
							type="button"
							size="small"
							variant="secondary"
							onClick={() => {
								if (props.threadPath) {
									window.location.href = props.threadPath;
								}
							}}
						>
							Open thread
						</Button>
					</Show>
				</VStack>
			</Show>
		</Card>
	);
};
